<div class="pad-top-20 row">
  <div class="column twelve lg-push-two md-eight md-push-two">
    <h2
      dsContent
      [contentPath]="'policy.underWritingFinalHeading'"
      class="bold-header margin-bottom-30"
      data-cy="underWritingFinalHeading"
    ></h2>
    <ul>
      @for (question of questions; track question) {
        <li class="margin-top-10">{{ question }}</li>
      }
    </ul>
  </div>
</div>
<div class="row">
  <div class="column twelve lg-push-two md-eight md-push-two">
    <call-to-action
      [displayBackButton]="true"
      [tertiaryButtonName]="'Cancel'"
      [primaryButtonName]="'None Apply'"
      (primaryEvent)="noneApplyClicked()"
      [secondaryButtonName]="'Yes'"
      (secondaryEvent)="clickedOnYes()"
      (tertiaryEvent)="cancelEvent.emit(true)"
      (backEvent)="goBackOneStep()"
    ></call-to-action>
  </div>
</div>
